import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { bindActionCreators as bindScopedActionCreators } from 'multireducer';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as alignmentActions from "../store/alignments/actions.js";
import { getAlignedOutcomes } from "../store/alignments/selectors.js";
import * as outcomePickerActions from "../store/OutcomePicker/actions.js";
import AlignmentWidget from "../components/AlignmentWidget/index.js";
import WithArtifact from "../components/WithArtifact.js";
import ConnectedOutcomeTray from "./ConnectedOutcomeTray.js";
import { getFeatures } from "../store/features/selectors.js";
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var scope = ownProps.scope;
  return {
    tray: ConnectedOutcomeTray,
    alignedOutcomes: getAlignedOutcomes(state, scope),
    features: getFeatures(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var scope = ownProps.scope;
  return _objectSpread(_objectSpread({}, bindScopedActionCreators(outcomePickerActions, dispatch, scope)), bindScopedActionCreators(alignmentActions, dispatch, scope));
};
var ConnectedAlignmentWidget = compose(connect(mapStateToProps, mapDispatchToProps), WithArtifact)(AlignmentWidget);
export default ConnectedAlignmentWidget;